import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Payment } from '../_models/payment';
import { StripePayment } from '../_models/payment';

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  webSetting = 'settings/'
  orderUrl = 'create-order/'
  stripeUrl = 'stripe-payments/'
  public getWebSettings(key: string) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + this.webSetting + key + "/";

    return this.httpClient.get(url).pipe(map(data => {
      return data['value'];
    }));
  }

  public postStripeOrder(stripeJson: any, amount: string, currency: string, plan_id: string,
    plan_text: string, userName: string, address: string, city: string, state: string,
    country: string, postcode: string, newAmount: string, totalUsers: string, isCustomPlan: boolean) {
    const api_root = environment.REST_API_SERVER;
    // console.log(amount +" - "+currency +" - "+plan_id +" - "+plan_text)
    let url = api_root + this.stripeUrl;
    const data = {
      "stripe_obj": stripeJson,
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "plan_text": plan_text,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe'
    }
    return this.httpClient.post<any>(url, data);
  }

  api_root: string = environment.REST_API_SERVER;
  public getDamPlans() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'dam-plans/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }
}
